module.exports = __webpack_public_path__ + "img/tabelleloeschen.f376a93.svg";